export default __webpack_public_path__ + "static/media/phone_white.5c23f11d.svg";